import { Color } from 'three';
import { IGradient } from '../types';

export const GRAYSCALE: IGradient = [
  [0, new Color(0, 0, 0)],
  [1, new Color(1, 1, 1)],
];
